import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

export default function PriceFilter(props) {
  const router = useRouter();

  const [priceFilter, setpriceFilter] = useState(['', '']);
  let { price: price } = router.query;

  useEffect(() => {
    if (price) {
      setpriceFilter(price);
    } else {
      setpriceFilter(['', '']);
    }
  }, [price, router.query]);

  return (
    <>
      <div className="filter__group-box ">
        <div className="sign__group " style={{ marginBottom: 8 }}>
          <label className="filter__label">Price ($)</label>
          <input
            type="number"
            onWheel={(e) => e.target.blur()}
            name="min"
            className="sign__input"
            placeholder="Min"
            value={priceFilter[0]}
            onChange={(e) => {
              setpriceFilter([e.target.value, priceFilter[1]]);
            }}
          />
        </div>
        <div className="sign__group" style={{ marginBottom: 8 }}>
          <input
            type="number"
            onWheel={(e) => e.target.blur()}
            name="max"
            className="sign__input"
            placeholder="Max"
            value={priceFilter[1]}
            onChange={(e) => {
              setpriceFilter([priceFilter[0], e.target.value]);
            }}
          />
        </div>
      </div>
      <div className="pt-2 pb-1" style={{ color: 'red' }}>
        {priceFilter[1] &&
          priceFilter[1] !== '' &&
          priceFilter[0] &&
          priceFilter[0] !== '' &&
          Number(priceFilter[0]) > Number(priceFilter[1]) &&
          'Minimum must be less than maximum'}
      </div>

      {(() => {
        if (priceFilter[0] || priceFilter[1]) {
          return (
            <button
              className={`mb-4 filter__btn filter_btn_active ${
                priceFilter[1] &&
                priceFilter[1] !== '' &&
                priceFilter[0] &&
                priceFilter[0] !== '' &&
                Number(priceFilter[0]) > Number(priceFilter[1]) &&
                'Minimum must be less than maximum'
                  ? 'disable_btn'
                  : ''
              }`}
              type="button"
              onClick={(e) => {
                console.log('priceFilter', priceFilter);
                props.updateRoute(['price', priceFilter], 'addToArr');
              }}
              disabled={
                priceFilter[1] &&
                priceFilter[1] !== '' &&
                priceFilter[0] &&
                priceFilter[0] !== '' &&
                Number(priceFilter[0]) > Number(priceFilter[1]) &&
                'Minimum must be less than maximum'
                  ? true
                  : false
              }
            >
              Apply
            </button>
          );
        }
      })()}
    </>
  );
}
